<template>
    <div class="login clearfix">
        <div class="bg-box">
            <div class="logo-box">
                <img :src="logoLogin">
            </div>
        </div>
        <p class="title">
          <span v-show="loginShow">智慧新工业，便捷云服务</span>
        </p>
        <div class="login-box" v-show="loginShow">
            <!-- 正常状态登录 -->
            <div>
                <p class="login-title">欢迎登陆</p>
                <div class="tab clearfix">
                    <p class="f-l" @click="activeName = 0" :class="{'active-lab':activeName==0}">账号密码登录</p>
                    <p class="f-r" @click="activeName = 1" :class="{'active-lab':activeName==1}">手机验证码登录</p>
                </div>
                <div v-show="activeName==0">
                    <el-form :model="ruleForm" :rules="rules" ref="passForm" class="clearfix">
                        <el-form-item prop="account" autocomplete="off">
                            <div :class="[{'err-active':errAccountShow},'account',{'keydown':keydown=='account'}]">
                                <span class="label">账号</span>
                                <el-input v-model="ruleForm.account" id="username" placeholder="请输入用户id或手机号" @keyup.enter.native="passLogin('passForm')" @focus="keydown='account'" @blur="keydown=''"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item prop="password" autocomplete="off" class="m-b-12">
                            <div :class="[{'err-active':errPassShow},'password',{'keydown':keydown=='password'}]">
                                <span class="label">密码</span>
                                <el-input v-model="ruleForm.password" id="password" show-password placeholder="请输入密码" @keyup.enter.native="passLogin('passForm')" @focus="keydown='password'" @blur="keydown=''"></el-input>
                            </div>
                        </el-form-item>
                        <span class="retrieve" @click="operate('forgotShow')">找回密码</span>
                        <el-button type="primary" class="login-btn" @click="passLogin('passForm')" id="login1">登录</el-button>
                    </el-form>
                </div>
                <div v-show="activeName==1">
                    <el-form :model="ruleForm" :rules="rules" ref="verifyCodeForm" class="clearfix">
                        <el-form-item prop="mobile" autocomplete="off">
                            <div :class="[{'err-active':errAccountShow},'account',{'keydown':keydown=='account2'}]">
                                <span class="label">手机号</span>
                                <el-input v-model="ruleForm.mobile" id="mobile" placeholder="请输入手机号" @keyup.enter.native="verifyLogin('verifyCodeForm')" @focus="keydown='account2'" @blur="keydown=''"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item prop="verifyCode" autocomplete="off" class="m-b-12">
                            <div :class="[{'err-active':errPassShow},'password',{'keydown':keydown=='verifyCode'}]">
                                <span class="label">验证码</span>
                                <el-input v-model="ruleForm.verifyCode" id="verifyCode" placeholder="请输入验证码" @keyup.enter.native="verifyLogin('verifyCodeForm')" class="w-212" @focus="keydown='verifyCode'" @blur="keydown=''"></el-input>
                                <div class="code-box">
                                    <p class="get-code" v-show="getCodeShow" @click.stop="getCode('verifyCodeForm')" id="getCode" >{{timerTxt}}</p>
                                    <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                                </div>
                            </div>
                        </el-form-item>
                        <el-button type="primary" class="login-btn m-t-70" @click="verifyLogin('verifyCodeForm')" id="login2">登录</el-button>
                    </el-form>
                </div>
            </div>
            <!-- 错误消息 -->
            <div class="err-box" v-show="errAccountShow">
                <img :src="tips" class="tips-icon">
                <span>{{errtext}}</span>
                <span class="err-sj"></span>
            </div>
            <!-- 错误消息 -->
            <div class="err-box pass" v-show="errPassShow">
                <img :src="tips" class="tips-icon">
                <span>{{errtext}}</span>
                <span class="err-sj"></span>
            </div>
        </div>
        <!-- 首次登录 -->
        <div class="first-box" v-if="firstLoginShow">
            <div class="forgot-pass">
                <p class="first-top">首次登录</p></p>
                <el-form :model="ruleForm" :rules="rules" ref="firstForm" class="clearfix w-380 ">
                    <el-form-item prop="newPass" autocomplete="off" class="m-b-12" >
                        <div class="account w-90" :class="{'keydown':keydown=='newPass'}">
                            <span class="label">请输入新密码</span>
                            <el-input v-model="ruleForm.newPass" id="newPass" @focus="keydown='newPass'" @blur="keydown=''" show-password  @keyup.enter.native="firstLogin('firstForm')" placeholder="请输入8位密码，其中包含大小写字母，数字"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="confirmPass" autocomplete="off" class="m-b-12" >
                        <div class="account w-90" :class="{'keydown':keydown=='confirmPass'}">
                            <span class="label">请确认新密码</span>
                            <el-input v-model="ruleForm.confirmPass" id="confirmPass" @focus="keydown='confirmPass'" @blur="keydown=''" show-password  @keyup.enter.native="firstLogin('firstForm')" placeholder="请输入8位密码，其中包含大小写字母，数字"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="mobile" autocomplete="off" class="m-b-12">
                        <div class="account" :class="{'keydown':keydown=='mobile2'}">
                            <span class="label">手机号</span>
                            <el-input v-model="ruleForm.mobile" id="phone" @focus="keydown='mobile2'" @blur="keydown=''" @keyup.enter.native="firstLogin('firstForm')" placeholder="请输入手机号" @input="ruleForm.mobile=ruleForm.mobile.replace(/[^\d]/g,'')" maxlength="11"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="verifyCode" autocomplete="off" class="m-b-12">
                        <div class="password" :class="{'keydown':keydown=='verifyCode2'}">
                            <span class="label">验证码</span>
                            <el-input v-model="ruleForm.verifyCode" id="verifyCode2" @focus="keydown='verifyCode2'" @blur="keydown=''" placeholder="请输入验证码"class="w-212"  @keyup.enter.native="firstLogin('firstForm')"></el-input>
                            <div class="code-box">
                                <p class="get-code" v-show="getCodeShow" @click.stop="getCode('firstForm')" id="getCode2" >{{timerTxt}}</p>
                                <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                            </div>
                        </div>
                    </el-form-item>
                    <el-button type="primary" class="login-btn m-t-22" @click="firstLogin('firstForm')" id="firstLogin">确认</el-button>
                </el-form>
            </div>
            <!-- <p class="bq">深圳市xxxx网络科技有限公司版权所有</p> -->
        </div>
        <!-- 找回密码 -->
        <div v-if="forgotShow">
            <div class="forgot-pass">
                <p class="first-top">找回密码 <span class="toLogin" @click="toLogin">返回</span></p>
                <el-form :model="ruleForm" :rules="rules" ref="forgotForm" class="clearfix m-t-84 w-367">
                    <el-form-item prop="mobile" autocomplete="off" class="m-t-22" >
                        <div class="account" :class="{'keydown':keydown=='mobile3'}">
                            <span class="label">手机号</span>
                            <el-input v-model="ruleForm.mobile" id="mobile3" @focus="keydown='mobile3'" @blur="keydown=''" placeholder="请输入手机号" @input="ruleForm.mobile=ruleForm.mobile.replace(/[^\d]/g,'')" maxlength="11"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="verifyCode" autocomplete="off" class="m-b-12">
                        <div class="password" :class="{'keydown':keydown=='verifyCode3'}">
                            <span class="label">验证码</span>
                            <el-input v-model="ruleForm.verifyCode" id="verifyCode3" @focus="keydown='verifyCode3'" @blur="keydown=''" placeholder="请输入验证码"class="w-212"></el-input>
                            <div class="code-box">
                                <p class="get-code" v-show="getCodeShow" @click.stop="getCode('forgotForm')" id="getCode12" >{{timerTxt}}</p>
                                <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                            </div>
                        </div>
                    </el-form-item>
                    <el-button type="primary" class="login-btn m-t-84" @click="forgotPass('forgotForm')" id="forgotPass">确认</el-button>
                </el-form>
            </div>
            <!-- <p class="bq">深圳市xxxx网络科技有限公司版权所有</p> -->
        </div>

        <!-- 重置密码 -->
        <!-- <div v-show="resetShow">
            <p class="first-top">修改密码</p>
        </div> -->
        <!-- 重置密码 -->
        <div class="reset-pass" v-if="resetShow">
            <div class="forgot-pass">
                <p class="first-top">修改密码 <span class="toLogin" @click="toLogin">返回</span></p>
                <el-form :model="ruleForm" :rules="rules" ref="resetForm" class="clearfix m-t-70 w-380">
                    <el-form-item prop="newPass" autocomplete="off" class="m-b-12" >
                        <div class="account w-90" :class="{'keydown':keydown=='newPass3'}">
                            <span class="label">请输入新密码</span>
                            <el-input v-model="ruleForm.newPass" id="newPass3" @focus="keydown='newPass3'" @blur="keydown=''" show-password placeholder="请输入8位密码，其中包含大小写字母，数字"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="confirmPass" autocomplete="off" class="m-b-12" >
                        <div class="account w-90" :class="{'keydown':keydown=='confirmPass3'}">
                            <span class="label">请确认新密码</span>
                            <el-input v-model="ruleForm.confirmPass" id="confirmPass3" @focus="keydown='confirmPass3'" @blur="keydown=''" show-password placeholder="请输入8位密码，其中包含大小写字母，数字"></el-input>
                        </div>
                    </el-form-item>
                    <el-button type="primary" class="login-btn m-t-84" @click="resetPass('resetForm')" id="resetPass">确认</el-button>
                </el-form>
            </div>
            <!-- <p class="bq">深圳市xxxx网络科技有限公司版权所有</p> -->
        </div>

    </div>
</template>
<script>
export default {
    data() {
        var validatePhone = (rule, value, callback) =>{
            let reg=/^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
            if(value == "" || value == null){
                callback(new Error('手机号不能为空'));
            }else if(!reg.test(value)){
                callback(new Error('请输入正确的手机号码'));
            }else{
                callback();
            }
        }
        var validatePass = (rule, value, callback) =>{
            let reg =  /^(?=.*[A-Za-z])(?=.*\d)[^]{8,16}$/;
            if(value == "" || value == null){
                callback(new Error('新密码不能为空'));
            }else if(!reg.test(value)){
                callback(new Error('密码必须为8~16位，同时包含英文和数字'));
                // this.ruleForm.newPass = '';
            }else{
                callback();
            }
        }
        var valiConfirmPass = (rule, value, callback) =>{
            if(value == "" || value == null){
                callback(new Error('确认密码不能为空'));
            }else if(value != this.ruleForm.newPass){
                callback(new Error('确认密码与新密码不一致'));
                this.ruleForm.confirmPass = "";
            }else{
                callback();
            }
        }
        var verifyCode = (rule, value, callback) =>{
            if(value == "" || value == null){
                callback(new Error('验证码不能为空'));
            }else if(value.length != 4){
                callback(new Error('请输入4位验证码'));
            }else{
                callback();
            }
        }
        return {
            logoLogin:require("@/assets/image/index/logoLogin.png"),
            logo1:require("@/assets/image/index/logo1.png"),
            account:require("@/assets/image/index/account.png"),
            password:require("@/assets/image/index/password.png"),
            tips:require("@/assets/image/index/tips.png"),
            activeName:0,
            errAccountShow:false,
            errPassShow:false,
            loginShow:true,
            forgotShow:false,
            firstLoginShow:false,
            resetShow:false,
            countdownShow:false,
            second:60,          //定时器
            getCodeShow:true,
            timer:null,
            timerTxt:"获取验证码",
            ruleForm:{
                account:"",
                password:"",
                mobile:"",
                verifyCode:"",
                newPass:"",
                confirmPass:"",
            },
            keydown:'',
            rules:{
                account:[{required: true, message: "账号不能为空", trigger: 'blur'}],
                password:[{required: true, message: "密码不能为空", trigger: 'blur'}],
                mobile:[{required: true, validator: validatePhone, trigger: 'blur'}],
                verifyCode:[{required: true, validator: verifyCode, trigger: 'blur'}],
                newPass:[{validator: validatePass, trigger: 'blur'}],
                confirmPass:[{validator: valiConfirmPass, trigger: 'blur'}]
            },
            passToken:"",   //忘记密码token
            errtext:"",     //错误提示文本
            link:null,
            title:null,
        }
    },
    created() {
        this.link=require('@/assets/image/index/favicon'+this.cssType+'.png')
        this.title = this.cssType==0?'捷云物联':'天机云平台'
        this.changeIco()
        this.$store.state.isLook = false
        localStorage.setItem('isLook',false)
        document.title = this.title; // 动态修改网站标题
    },
    methods: {
        //获取验证码
        getCode(name){
            this.$refs[name].validateField("mobile",(err) => {
                if(err==''){
                    let parm = {mobile:this.ruleForm.mobile}
                    if(name == 'firstForm'){
                        // console.log('firstForm')
                        parm.firstBind="first"
                    }
                    this.post('/UserProfile/sendVerifyCode',parm).then((res)=>{
                        if(res.success){
                            this.getCodeShow=false;
                            this.countdownShow=true;
                            this.$message({
                                message: '验证码发送成功',
                                type: 'success'
                            });
                            const TIME_COUNT = 60;
                            if (!this.timer) {
                                this.second = TIME_COUNT;
                                this.timer = setInterval(() => {
                                    if (this.second > 0 && this.second <= TIME_COUNT) {
                                        this.second--;
                                    }else{
                                        this.getCodeShow = true;
                                        this.countdownShow=false;
                                        this.timerTxt = '再次获取'
                                        clearInterval(this.timer);
                                        this.timer = null;
                                    }
                                }, 1000)
                            }
                        }else{
                            this.$message({
                                message: `验证码发送失败：${res.message}`,
                                type: 'warning'
                            });
                        }
                    })
                }
            })
        },
        //打开弹窗
        operate(name){
            this[name]=true;
            this.timerTxt="获取验证码";
            this.getCodeShow = true;
            this.countdownShow=false;
            clearInterval(this.timer);
            this.timer = null;
            if(name=='forgotShow'){
                this.loginShow=false;
            }
        },
        //密码登录
        passLogin(name){
            this.$refs[name].validate((valid) => {
                this.errShow = false
                // if(localStorage.getItem('indexLoad')){
                //   this.$confirm('禁止登陆多个用户', '提示', {
                //     confirmButtonText: '确定',
                //     showCancelButton:false,
                //     type: 'warning'
                //   })
                //   return
                // }
                if(valid){
                    let parm = {
                        userName:this.ruleForm.account,
                        password:this.ruleForm.password,
                        requestId:1,
                    }
                    this.post('/UserProfile/login',parm).then((res)=>{
                        if(res.success){
                            localStorage.setItem("loginState",true);
                            this.$store.state.userData=res.result
                            localStorage.setItem('userData',JSON.stringify(res.result))
                            localStorage.setItem("indexLoad",true);
                            // var cookieData=this.getCookie('SESSION'); //cookie赋值给变量。
                            // console.log(cookieData)
                            if(this.$store.state.client){
                              this.$store.state.client.end()
                            }
                            if(sessionStorage.getItem('routerNext')){
                            	let router = sessionStorage.getItem('routerNext');
                                sessionStorage.removeItem('routerNext')
                                if(router=='/login'||router=='/'){
                                    router = '/Overviews'
                                }
                            	this.$router.push({path:router});
                            }else{
                            	this.$router.push({path:"/Overviews"});
                            }

                        }else{
                            this.loginState(res.result,res.message);
                        }
                    })
                }
            })
        },
        //验证码登录
        verifyLogin(name){
            this.$refs[name].validate((valid) => {
                this.errShow = false
                // if(localStorage.getItem('indexLoad')){
                //   this.$confirm('禁止登陆多个用户', '提示', {
                //     confirmButtonText: '确定',
                //     showCancelButton:false,
                //     type: 'warning'
                //   })
                //   return
                // }
                if(valid){
                    let parm = {
                        mobile:this.ruleForm.mobile,
                        verifyCode:this.ruleForm.verifyCode
                    }
                    this.post('/UserProfile/loginByVerifyCode',parm).then((res)=>{
                        if(res.success){
                            localStorage.setItem("loginState",true);
                            this.$store.state.userData=res.result
                            localStorage.setItem('userData',JSON.stringify(res.result))
                            if(this.$store.state.client){
                              this.$store.state.client.end()
                            }
                            if(sessionStorage.getItem('routerNext')){
                            	let router = sessionStorage.getItem('routerNext');
                                if(router=='/login'||router=='/'){
                                    router = '/Overviews'
                                }
                            	sessionStorage.removeItem('routerNext')
                            	this.$router.push({path:router});
                            }else{
                            	this.$router.push({path:"/Overviews"});
                            }
                        }else{
                            this.loginState(res.result,res.message);
                        }
                    })
                }
            })
        },
        //首次登录
        firstLogin(name){
            this.$refs[name].validate((valid) => {
                if(valid){
                    let parm = {
                        newPassword:this.ruleForm.newPass,
                        mobile:this.ruleForm.mobile,
                        verifyCode:this.ruleForm.verifyCode
                    }
                    this.post('/UserProfile/bindMobile',parm).then((res)=>{
                        // console.log(parm,res)
                        if(res.success){
                            localStorage.setItem("loginState",true);
                            this.$store.state.userData=res.result;
                            localStorage.setItem('userData',JSON.stringify(res.result))
                            this.getCodeShow = true;
                            this.countdownShow=false;
                            this.timerTxt = '获取验证码';
                            clearInterval(this.timer);
                            this.timer = null;
                            this.ruleForm = this.$options.data().ruleForm;
                            if(this.$store.state.client){
                              this.$store.state.client.end()
                            }
                            if(sessionStorage.getItem('routerNext')){
                            	let router = sessionStorage.getItem('routerNext');
                                if(router=='/login'||router=='/'){
                                    router = '/Overviews'
                                }
                            	sessionStorage.removeItem('routerNext')
                            	this.$router.push({path:router});
                            }else{
                            	this.$router.push({path:"/Overviews"});
                            }
                        }else{
                            this.$message({
                                message: `绑定失败: ${res.message}`,
                                type: 'warning'
                            });
                        }
                    })
                }
            })
        },
        changeIco(){
            let $favicon = document.querySelector('link[rel="icon"]');
            if ($favicon !== null) {
                $favicon.href = this.link;
            } else {
                $favicon = document.createElement("link");
                $favicon.rel = "icon";
                $favicon.href = this.link;
                document.head.appendChild($favicon);
            }
        },
        //忘记密码
        forgotPass(name){
            this.$refs[name].validate((valid) => {
                if(valid){
                    let parm = {
                        mobile:this.ruleForm.mobile,
                        verifyCode:this.ruleForm.verifyCode
                    }
                    this.post('/UserProfile/forgotPassword',parm).then((res)=>{
                        // console.log(parm,res)
                        if(res.success){
                            this.ruleForm = this.$options.data().ruleForm;
                            this.resetShow=true;
                            this.forgotShow = false
                            this.getCodeShow = true;
                            this.countdownShow=false;
                            this.timerTxt = '获取验证码';
                            clearInterval(this.timer);
                            this.passToken = res.result;
                            this.timer=null;
                        }else{
                            this.$message({
                                type:'warning',
                                message:res.message
                            })
                        }
                    })
                }
            })
        },
        //重置密码
        resetPass(name){
            this.$refs[name].validate((valid) => {
                if(valid){
                    let parm = {
                        token:this.passToken,
                        password:this.ruleForm.newPass
                    }
                    this.post('/UserProfile/resetPassword',parm).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '重置成功，请重新登录',
                                type: 'success'
                            });
                            this.ruleForm = this.$options.data().ruleForm;
                            this.passToken = '';
                            this.resetShow = false;
                            this.loginShow = true;
                        }else{
                            this.$message({
                                message: `重置失败: ${res.message}`,
                                type: 'warning'
                            });
                        }
                    })
                }
            })
        },
        toLogin(){
            this.ruleForm = this.$options.data().ruleForm
            this.loginShow=true;
            this.forgotShow = false;
            this.resetShow = false;
        },
        //登录状态码管理
        loginState(state,errtext){
            // console.log(state,errtext)
            this.errAccountShow=false
            this.errPassShow=false;
            switch (state){
                case 1111:
                    this.errShow=false;
                    this.firstLoginShow = true;
                    this.loginShow = false;
                    this.ruleForm = this.$options.data().ruleForm;
                    break;
                case 4001:
                    this.errtext = errtext;
                    this.errAccountShow=true
                    break;
                case 4002:
                    this.errtext = errtext;
                    this.errPassShow=true
                    break;
                case 4003:
                    this.activeName = 1;
                    // this.errtext="只能使用验证码登录,您输入的密码错误次数已达到3/3次数";
                    break;
                case 4004:
                    this.errtext = '请勿越权使用';
                    this.errAccountShow=true
                    break;
                case 4005:
                    this.errShow=false;
                    this.firstLoginShow = true;
                    this.loginShow = false;
                    this.ruleForm = this.$options.data().ruleForm;
                    break;
                case 4007:
                    this.errtext = errtext;
                    this.errPassShow=true;
                    break;
                case 4008:
                    this.errtext = errtext;
                    this.errPassShow=true;
                    break;
                default:
                    this.errtext = errtext;
                    this.errAccountShow=true
                    break;
            }
        },
    },
    watch: {
        activeName(){
            this.errAccountShow=false;
            this.errPassShow=false;
            this.$refs.verifyCodeForm.clearValidate()
            this.$refs.passForm.clearValidate()
        }
    },
}
</script>

<style scoped>
    .login{
        width: 100%;
        height: 100%;
        min-width: 1338px;
        min-height: 786px;
        position: absolute;
    }
    .bg-box{
        width: 100%;
        background: url("@../../../assets/image/index/bg2.png") no-repeat;
        background-size: 100% 100%;
        position: fixed;
        top: 0;
        bottom: 0;
    }
    .logo-box{
        text-align: center;
        /* float: left; */
        position: fixed;
        top: 65px;
        left: 80px;
    }
    .logo-box img{
        /* width: 10px; */
        margin-bottom: 74px;
    }
    .title{
        color: #fff;
        font-size: 38px;
        padding-top: 143px;
        text-align: center;
        margin-bottom: 48px;
        position: relative;
    }
    .login-box{
        width: 600px;
        height: 543px;
        background: #fff;
        position: absolute;
        margin-left: -300px;
        left: 50%;
        padding: 0 125px;
        box-sizing: border-box;
    }
    .login-title{
        font-size: 30px;
        padding-top: 58px;
        font-weight: 600;
    }
    .keydown{
        border-bottom: 2px solid #5087e4 !important;
    }
    .keydown .label{
        color: #5087e4;
    }
    .err-active .label{
        color: #ff2626;
    }
    .tab{
        width: 315px;
        margin: 52px auto 36px;
        text-align: center;
        /* font-weight: 600; */
    }
    .tab>p{
        font-size: 18px;
        color: #ababab;
        height: 18px;
        width: 49%;
        line-height: 18px;
        cursor: pointer;
    }
    .tab>p:first-child{
        border-right: 2px solid #ababab;
    }
    .retrieve{
        float: right;
        color: #a9a9a9;
        cursor: pointer;
    }
    .m-b-12 {
        margin-bottom: 5px !important;
    }
    .login-btn{
        margin-top: 52px;
        width: 100%;
        height: 38px;
    }
    .form-icon{
        position: absolute;
        left: 12px;
        top: 10px;
        z-index: 99;
    }
    .m-t-70{
        margin-top: 70px !important;
    }
    .m-t-70.w-380{
        padding: 0 !important;
    }
    .m-t-22{
        margin-top: 22px !important;
    }
    .tips-icon{
        position: absolute;
        left: 12px;
        top: 12px;
    }
    .first-box{
        padding-bottom:55px !important;
    }
    #firstLogin{
        margin-top: 42px !important;
    }
    .first-box,.forgot-pass,.reset-pass{
        width: 813px;
        background-color: #fff;
        margin:0 auto;
        padding-bottom: 15px;
        position: relative;
    }
    .forgot-top{
        text-align: left;
        width: 813px;
        margin: 130px auto 0;
        padding-bottom: 12px;
        background: #f7f7f7;
    }
    .forgot-top span{
        font-size: 24px;
        position: relative;
        top: -20px;
        left: 12px;
    }
    .bq{
        color: #afafaf;
        text-align: center;
        margin-top: 58px;
        font-size: 15px;
    }
    .m-t-84{
        margin-top: 42px;
        margin-bottom: 62px;
    }
    .first-top{
        font-size: 20px;
        line-height: 58px;
        /* background-color: #308ff0; */
        /* color: #fff; */
        text-align: center;
        position: relative;
        top: 26px;
    }
    .w-367{
        width: 367px;
        margin: 0 auto;
        padding-top: 44px;
    }
    .toLogin{
        float: left;
        margin-left: 18px;
        font-size: 13px;
        cursor: pointer;
        position: absolute;
        color: #5087e4;
        top: -28px;
        left: 0
    }
    .w-380{
        width: 380px;
        margin: 0 auto;
        padding-top: 44px;
    }
    /* 倒计时 */
    .code-box {
        float: right;
        width: 110px;
        line-height: 36px;
        text-align: center;
        color: #fff;
        margin-top: 12px;
    }
    .get-code{
        background-color: #5087e4;
        border-radius: 5px;
        cursor: pointer;
    }
    .countdown{
        background-color: #c2c2c2;
        border-radius: 5px;
    }
    .err-box{
        position: absolute;
        width: 289px;
        right: 0;
        margin-right: -233px;
        background-color: #fff;
        border: 1px solid #ff2626;
        padding:0 10px;
        line-height: 36px;
        height: 36px;
        border-radius: 5px;
        bottom: 284px;
        padding-left: 30px;
        text-align: left;
        z-index: 1;
    }
    .err-box.pass{
        bottom: 183px;
    }
    .active-lab{
        color: #5087e4 !important;
    }
    .err-active{
        border-color: #ff2626 !important;
        color: #ff2626 !important;
    }
    .label-active{
        border-color: #5087e4 !important;
        color: #5087e4 !important;
    }
    /* .err-sj{
        width: 6px;
        height: 6px;
        background-color: #fff;
        border: 1px solid #f00;
        position: absolute;
        top: 15px;
        left: -8px;
        transform: rotate(45deg);
        z-index: 0;
    } */
    .err-box::before{
        content: " ";
        position: absolute;
        top: 12px;
        left: -2px;
        width: 0;
        height: 0;
        border-bottom:8px solid transparent;
        border-top: 8px solid #ff2626;
        border-right:8px solid transparent;
        transform: rotate(-45deg); /*顺时针旋转90°*/
    }
    .err-box::after{
        content: " ";
        position: absolute;
        top: 12px;
        left: -1px;
        width: 0;
        height: 0;
        border-bottom:8px solid transparent;
        border-top: 8px solid #fff;
        border-right:8px solid transparent;
        transform: rotate(-45deg); /*顺时针旋转90°*/
    }
    .forgot-pass .account,.forgot-pass .password{
        line-height:60px !important;
        margin-top:5px;
    }
    .account,.password{
        font-size: 15px;
        text-align: left;
        line-height: 65px;
        border-bottom: 2px solid #ebeaed;
    }
    .account>span,.password>span{
        width: 60px;
        display: inline-block;
    }
    .account .el-input,.password .el-input{
        width: calc(100% - 68px) !important;

    }
    .account.w-90>span,.password.w-90>span{
        width: 90px;
        display: inline-block;
    }
    .account.w-90 .el-input,.password.w-90 .el-input{
        width: calc(100% - 98px) !important;
    }
</style>
<style>
    .login .login-box .el-tabs__item{
        width: 150px !important;
        height: 25px !important;
        line-height: 25px !important;
        box-sizing: border-box !important;
        margin: 12px 0 !important;
        padding: 0 !important;
    }
    .login .login-box .el-form-item__label{
        line-height: 26px;
        margin-top: 12px;
    }
    .login .login-box :first-child .el-tabs__item{
        border-right: 1px solid #c9c9c9 !important;
    }
    .login .login-box .el-input__inner{
        line-height: 36px !important;
        height: 36px !important;
        padding: 0 10px !important;
    }
    .login .first-box .el-input__inner,.reset-pass .el-input__inner{
        padding-left: 10px !important;
    }
    .login .account .el-input__inner, .password .el-input__inner{
        border: 0 !important;
    }
    .login .password .w-212.el-input{
        width: 154px !important;
        display: inline-block;
    }
    .login .el-form-item__error{
        margin-top: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/login.vue